export const specialties = [
  { 
    id: 'anxiety', 
    label: 'Anxiety', 
    slug: 'anxiety-therapy',
    seoTitle: 'Anxiety Therapy',
    description: 'Professional anxiety treatment and counseling services',
    keywords: ['anxiety therapy', 'anxiety treatment', 'anxiety counseling', 'panic disorder therapy'],
    longDescription: 'Specialized anxiety therapy services including cognitive behavioral therapy, exposure therapy, and mindfulness-based approaches for anxiety disorders, panic attacks, and phobias.'
  },
  { 
    id: 'depression', 
    label: 'Depression', 
    slug: 'depression-treatment',
    seoTitle: 'Depression Treatment',
    description: 'Comprehensive depression therapy and mental health support',
    keywords: ['depression therapy', 'depression treatment', 'depression counseling', 'mood disorder therapy'],
    longDescription: 'Evidence-based depression treatment including psychotherapy, cognitive behavioral therapy, and supportive counseling for major depression, seasonal depression, and mood disorders.'
  },
  { 
    id: 'trauma', 
    label: 'Trauma & PTSD', 
    slug: 'trauma-ptsd-therapy',
    seoTitle: 'Trauma & PTSD Therapy',
    description: 'Specialized trauma therapy and PTSD treatment services',
    keywords: ['trauma therapy', 'PTSD treatment', 'trauma counseling', 'EMDR therapy'],
    longDescription: 'Specialized trauma-informed therapy including EMDR, cognitive processing therapy, and prolonged exposure therapy for PTSD, complex trauma, and emotional recovery.'
  },
  { 
    id: 'relationships', 
    label: 'Relationships', 
    slug: 'relationship-counseling',
    seoTitle: 'Relationship Counseling',
    description: 'Professional relationship therapy and couples counseling',
    keywords: ['relationship counseling', 'relationship therapy', 'couples therapy', 'marriage counseling'],
    longDescription: 'Relationship counseling services focusing on communication skills, conflict resolution, intimacy issues, and strengthening emotional connections between partners.'
  },
  { 
    id: 'stress', 
    label: 'Stress Management', 
    slug: 'stress-management',
    seoTitle: 'Stress Management Therapy',
    description: 'Stress management techniques and therapeutic support',
    keywords: ['stress management', 'stress therapy', 'stress counseling', 'burnout therapy'],
    longDescription: 'Comprehensive stress management therapy including relaxation techniques, mindfulness training, and coping strategies for work stress, chronic stress, and burnout.'
  },
  { 
    id: 'grief', 
    label: 'Grief & Loss', 
    slug: 'grief-counseling',
    seoTitle: 'Grief Counseling',
    description: 'Compassionate grief therapy and bereavement support',
    keywords: ['grief counseling', 'grief therapy', 'bereavement support', 'loss counseling'],
    longDescription: 'Supportive grief counseling services helping individuals process loss, navigate bereavement, and develop healthy coping mechanisms during difficult times.'
  },
  { 
    id: 'addiction', 
    label: 'Addiction', 
    slug: 'addiction-therapy',
    seoTitle: 'Addiction Therapy',
    description: 'Professional addiction treatment and recovery support',
    keywords: ['addiction therapy', 'addiction treatment', 'substance abuse counseling', 'recovery therapy'],
    longDescription: 'Comprehensive addiction therapy services including individual counseling, group therapy, relapse prevention, and family support for substance abuse recovery.'
  },
  { 
    id: 'eating', 
    label: 'Eating Disorders', 
    slug: 'eating-disorder-therapy',
    seoTitle: 'Eating Disorder Therapy',
    description: 'Specialized eating disorder treatment and support',
    keywords: ['eating disorder therapy', 'anorexia treatment', 'bulimia therapy', 'binge eating therapy'],
    longDescription: 'Specialized eating disorder therapy including treatment for anorexia, bulimia, binge eating disorder, and body image issues with evidence-based approaches.'
  },
  { 
    id: 'ocd', 
    label: 'OCD', 
    slug: 'ocd-therapy',
    seoTitle: 'OCD Therapy',
    description: 'Obsessive-compulsive disorder therapy and treatment',
    keywords: ['OCD therapy', 'OCD treatment', 'obsessive compulsive therapy', 'ERP therapy'],
    longDescription: 'Specialized OCD therapy using exposure and response prevention (ERP), cognitive behavioral therapy, and acceptance-based approaches for obsessive-compulsive disorder.'
  },
  { 
    id: 'personality', 
    label: 'Personality Disorders', 
    slug: 'personality-disorder-therapy',
    seoTitle: 'Personality Disorder Therapy',
    description: 'Specialized therapy for personality disorders',
    keywords: ['personality disorder therapy', 'DBT therapy', 'borderline therapy', 'personality therapy'],
    longDescription: 'Specialized therapy for personality disorders including dialectical behavior therapy (DBT), schema therapy, and cognitive behavioral approaches.'
  },
  { 
    id: 'bipolar', 
    label: 'Bipolar Disorder', 
    slug: 'bipolar-therapy',
    seoTitle: 'Bipolar Disorder Therapy',
    description: 'Bipolar disorder therapy and mood stabilization support',
    keywords: ['bipolar therapy', 'bipolar treatment', 'mood disorder therapy', 'bipolar counseling'],
    longDescription: 'Comprehensive bipolar disorder therapy including mood stabilization, psychoeducation, and coping strategies for managing bipolar episodes and maintaining stability.'
  },
  { 
    id: 'adhd', 
    label: 'ADHD', 
    slug: 'adhd-therapy',
    seoTitle: 'ADHD Therapy',
    description: 'ADHD therapy and attention deficit support services',
    keywords: ['ADHD therapy', 'ADHD treatment', 'attention deficit therapy', 'ADHD counseling'],
    longDescription: 'ADHD therapy services including behavioral interventions, executive function training, and coping strategies for children and adults with attention deficit disorders.'
  },
  { 
    id: 'couples', 
    label: 'Couples Therapy', 
    slug: 'couples-therapy',
    seoTitle: 'Couples Therapy',
    description: 'Professional couples therapy and marriage counseling',
    keywords: ['couples therapy', 'marriage counseling', 'couples counseling', 'relationship therapy'],
    longDescription: 'Couples therapy services using evidence-based approaches like Gottman Method and Emotionally Focused Therapy to strengthen relationships and resolve conflicts.'
  },
  { 
    id: 'family', 
    label: 'Family Therapy', 
    slug: 'family-therapy',
    seoTitle: 'Family Therapy',
    description: 'Family therapy and systemic counseling services',
    keywords: ['family therapy', 'family counseling', 'family systems therapy', 'family support'],
    longDescription: 'Family therapy services focusing on improving communication, resolving conflicts, and strengthening family relationships through systemic and structural approaches.'
  },
  { 
    id: 'child', 
    label: 'Child Psychology', 
    slug: 'child-psychology',
    seoTitle: 'Child Psychology',
    description: 'Child psychology and pediatric mental health services',
    keywords: ['child psychology', 'child therapy', 'pediatric psychology', 'child counseling'],
    longDescription: 'Child psychology services including play therapy, behavioral interventions, and developmental support for children facing emotional and behavioral challenges.'
  }
] as const;

export type Specialty = typeof specialties[number]['id'];